
<div class="input-group">
  <span class="input-group-addon show-xl">{{ 'offer.jumpToShort' | translate }}</span>
  <span class="input-group-addon hide-xl">{{ 'offer.jumpTo' | translate }}</span>
  <input [(ngModel)]="page" (blur)="onBlur()"  (keyup)="onKeyUp($event)" type="text" (keypress)="onQuantityInput($event)" class="form-input" />
  <button class="btn btn-primary input-group-btn"><i class="fa fa-caret-right"></i></button>
</div>